import { forwardRef, TextareaHTMLAttributes } from 'react';

import classNames from 'classnames';
import { TextArea } from 'react-aria-components/TextArea';
import { useIntl } from 'react-intl';

import { Field, IFieldProps, useField } from '../Field/Field';

import styles from './textarea.module.scss';

interface ITextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement>,
    IFieldProps {
  height?: `${number}px` | `${number}rem` | `${number}em`;
}
const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>((props, ref) => {
  const {
    id,
    label,
    labelContent,
    helpText,
    errorMessage,
    wrapperClassName,
    className,
    disabled,
    error,
    placeholder,
    height = '144px',
    style,
    'aria-describedby': describedBy,
    'aria-invalid': ariaInvalid,
    ...restProps
  } = props;
  const intl = useIntl();
  const { fieldId, descriptionIds } = useField(
    id,
    describedBy,
    helpText,
    errorMessage,
    error,
  );
  return (
    <Field
      {...{
        fieldId,
        label,
        labelContent,
        helpText,
        errorMessage,
        error,
        wrapperClassName,
      }}
    >
      <TextArea
        {...restProps}
        ref={ref}
        id={fieldId}
        style={{ height, ...style }}
        className={classNames(styles.textarea, className, {
          [styles['textarea--error']]: error,
        })}
        disabled={disabled}
        aria-invalid={error || ariaInvalid}
        aria-describedby={descriptionIds}
        placeholder={placeholder ? intl.formatMessage({ id: placeholder }) : undefined}
      />
    </Field>
  );
});
Textarea.displayName = 'Textarea';
export { Textarea };
